export const META_AD_PREVIEW_TYPE = {
    NEWS_FEED: "news-feed",
    NEWS_FEED_DESKTOP: "news-feed-desktop",
    NEWS_FEED_VIDEO: "news-feed-video",
    NEWS_FEED_TAB: "news-feed-tab",
    FACEBOOK_REEL_MOBILE: "facebook-reel-mobile",
    FACEBOOK_REEL: "facebook-reel",
    FACEBOOK_STORY: "facebook-story",
    FACEBOOK_IN_STREAM_VIDEO_MOBILE: "facebook-in-stream-video-mobile",
    FACEBOOK_IN_STREAM_VIDEO_DESKTOP: "facebook-in-stream-video-desktop",
    FACEBOOK_IN_STREAM_BANNER_MOBILE: "facebook-in-stream-banner-mobile",
    FACEBOOK_IN_STREAM_BANNER_DESKTOP: "facebook-in-stream-banner-desktop",
    FACEBOOK_IN_STREAM_FULL_VIDEO: "facebook-in-stream-full-video",
    FACEBOOK_IN_STREAM_FULL_BANNER: "facebook-in-stream-full-banner",
    INSTAGRAM_FEED: "instagram-feed",
    INSTAGRAM_REEL: "instagram-reel",
    INSTAGRAM_STORY: "instagram-story"
} as const;

export type MetaAdPreviewType = (typeof META_AD_PREVIEW_TYPE)[keyof typeof META_AD_PREVIEW_TYPE];

export const META_AD_PREVIEW_OPTIONS = {
    [META_AD_PREVIEW_TYPE.INSTAGRAM_FEED]: {
        label: "Instagram Feed",
        value: META_AD_PREVIEW_TYPE.INSTAGRAM_FEED,
        width: 318,
        maxHeight: 398,
        minHeight: 90
    },
    [META_AD_PREVIEW_TYPE.INSTAGRAM_REEL]: {
        label: "Instagram Reel",
        value: META_AD_PREVIEW_TYPE.INSTAGRAM_REEL,
        width: 318,
        height: 567
    },
    [META_AD_PREVIEW_TYPE.INSTAGRAM_STORY]: {
        label: "Instagram Story",
        value: META_AD_PREVIEW_TYPE.INSTAGRAM_STORY,
        width: 318,
        height: 567
    },
    [META_AD_PREVIEW_TYPE.FACEBOOK_REEL]: {
        label: "Facebook Reel",
        value: META_AD_PREVIEW_TYPE.FACEBOOK_REEL,
        width: 318,
        height: 567
    },

    [META_AD_PREVIEW_TYPE.FACEBOOK_STORY]: {
        label: "Facebook Story",
        value: META_AD_PREVIEW_TYPE.FACEBOOK_STORY,
        width: 318,
        height: 567
    },
    [META_AD_PREVIEW_TYPE.NEWS_FEED]: {
        label: "Facebook Feed",
        subLabel: "(mobile)",
        value: META_AD_PREVIEW_TYPE.NEWS_FEED,
        width: 318,
        maxHeight: 398,
        minHeight: 90
    },
    [META_AD_PREVIEW_TYPE.NEWS_FEED_DESKTOP]: {
        label: "Facebook Feed",
        subLabel: "(desktop)",
        value: META_AD_PREVIEW_TYPE.NEWS_FEED_DESKTOP,
        width: 500,
        maxHeight: 398,
        minHeight: 90
    },
    [META_AD_PREVIEW_TYPE.FACEBOOK_REEL_MOBILE]: {
        label: "Facebook Video Feed",
        subLabel: "(fullscreen - mobile)",
        value: META_AD_PREVIEW_TYPE.FACEBOOK_REEL_MOBILE,
        width: 318,
        height: 567
    },
    [META_AD_PREVIEW_TYPE.NEWS_FEED_VIDEO]: {
        label: "Facebook Video Feed",
        subLabel: "(videos - mobile)",
        value: META_AD_PREVIEW_TYPE.NEWS_FEED_VIDEO,
        width: 318,
        maxHeight: 398,
        minHeight: 90
    },
    [META_AD_PREVIEW_TYPE.NEWS_FEED_TAB]: {
        label: "Facebook Video Feed",
        subLabel: "(video tab - mobile)",
        value: META_AD_PREVIEW_TYPE.NEWS_FEED_TAB,
        width: 318,
        maxHeight: 398,
        minHeight: 90
    },
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_VIDEO_MOBILE]: {
        label: "Facebook In-Stream Video",
        subLabel: "(mobile)",
        value: META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_VIDEO_MOBILE,
        width: 318,
        minHeight: 220,
        maxHeight: 400
    },
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_VIDEO_DESKTOP]: {
        label: "Facebook In-Stream Video",
        subLabel: "(desktop)",
        value: META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_VIDEO_DESKTOP,
        isDesktop: true,
        width: 500,
        minHeight: 220,
        maxHeight: 400
    },
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_BANNER_MOBILE]: {
        label: "Facebook In-Stream Banner",
        subLabel: "(mobile)",
        value: META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_BANNER_MOBILE,
        width: 318,
        minHeight: 220,
        maxHeight: 400
    },
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_BANNER_DESKTOP]: {
        label: "Facebook In-Stream Banner",
        subLabel: "(desktop)",
        value: META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_BANNER_DESKTOP,
        width: 500,
        minHeight: 220,
        maxHeight: 400
    },
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_FULL_VIDEO]: {
        label: "Facebook In-Stream Video",
        subLabel: "(mobile fullscreen)",
        value: META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_FULL_VIDEO,
        width: 318,
        inStreamWidth: 75,
        maxHeight: 400,
        minHeight: 180
    },
    [META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_FULL_BANNER]: {
        label: "Facebook In-Stream Banner",
        subLabel: "(mobile fullscreen)",
        value: META_AD_PREVIEW_TYPE.FACEBOOK_IN_STREAM_FULL_BANNER,
        width: 318,
        inStreamWidth: 75,
        maxHeight: 400,
        minHeight: 180
    }
} as const as {
    readonly [K in MetaAdPreviewType]: {
        readonly label: string;
        readonly subLabel?: string;
        readonly value: K;
        readonly width: number;
        readonly height?: number;
        readonly minHeight?: number;
        readonly maxHeight?: number;
        readonly inStreamWidth?: number;
    };
};
